export const PRINT_QUALITY_INFO = {
    TO_LARGE_FOR_ALL_PRINTING_MODES: {
        ID: 'TO_LARGE_FOR_ALL_PRINTING_MODES',
        TYPE: 'danger',
    },
    TO_LARGE_FOR_SELECTED_MATERIAL: {
        ID: 'NOT_PRINTABLE_FOR_SELECTED_MATERIAL',
        TYPE: 'warning',
    },
    WITHOUT_COMPLICATIONS_PRINTABLE: {
        ID: 'WITHOUT_COMPLICATIONS_PRINTABLE',
        TYPE: 'success',
    },
    MIGHT_CAUSE_PROBLEMS: {
        ID: 'MIGHT_CAUSE_PROBLEMS',
        TYPE: 'warning',
    },
    NOT_PRINTABLE: {
        ID: 'NOT_PRINTABLE',
        TYPE: 'danger',
    },
    INDETERMINATE: {
        ID: 'INDETERMINATE',
        TYPE: '',
    },
};
